import { network } from 'services/network';

export const updateReportTemplate = (params: QueryParams) => {
    return network.post('api/bo/reporting/updateTemplate', params);
};

export interface QueryParams {
    id: number;
    name: string;
    description: string;
    tags: number[];
}
